module.exports = __webpack_public_path__ + "00896f6f7c1061af75be4ee9e156c13e.pdf";